export enum AlarmsGlobalMonitorStatus {
    LOADING,
    LOADED,
}

export enum AlarmStatus {
    CLOSED,
    NOT_IN_CHARGE,
    IN_CHARGE,
    RECENTLY_CLOSED,
}

export enum AlarmSeverity {
    URGENT,
    HIGH,
    WARNING,
}

export enum AlarmSeverityGuid {
    URGENT = "fa57ce40-6e70-4ec0-8b62-45a30a48490f",
    HIGH = "78f15bf7-b9a6-4a66-b4c4-8145dc4f3384",
    WARNING = "f7034711-90b3-44ef-99f2-2b9185882c02",
}

export enum AlarmSeverityColor {
    URGENT = "#f5050a",
    HIGH = "#ff8c05",
    WARNING = "#FFFF00",
}

export interface JSONAlarmStatus {
    code: number;
    name: string;
    image?: string;
}

export interface JSONAlarmCategoryStatistics {
    categoryId: number;
    categoryGuid: string;
    categoryName: string;
    statusStatistics: JSONAlarmStatusCount[];
    alarmTypes: JSONAlarmTypeInformation[];
}

export interface JSONAlarmStatusCount {
    statusId: number;
    count: number;
    severitiesCount: JSONAlarmSeverityCount[];
}

export interface JSONAlarmSeverityCount {
    severityGuid: string;
    count: number;
}

export interface JSONAlarmTypeInformation {
    id: number;
    name: string;
    description: string;
    severity: string;
}

export interface AlarmStatusInfo {
    statusId: number;
    status: AlarmStatus;
    name: string;
    image?: string;
}

export interface AlarmStatusCount {
    statusInfo: AlarmStatusInfo;
    count: number;
}

export interface JSONAlarmSeverity {
    guid: string;
    name: string;
    color: string;
    borderColor: string;
}

export interface AlarmSeverityCount {
    severityInfo: JSONAlarmSeverity;
    count: number;
}
